import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApi, deleteApi } from 'redux/apis';

// Get Expense Journal Preview Entries
export const getExpenseJournalPreviewEntriesAction = createAsyncThunk(
	'expenseJournal/getPreviewEntries',
	async (params: any, { rejectWithValue }) => {
		try {
			const response = await getApi('/expense-journal/preview-entries', {
				...params,
				companyId: localStorage.getItem('companyId'),
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

// Get Expense Journal List (for main journal list page)
export const getExpenseJournalListAction = createAsyncThunk(
	'expenseJournal/getList',
	async (
		params: {
			page?: number;
			limit?: number;
			search?: string;
			status?: string;
			sort?: string;
			sortType?: string;
			year?: number;
		},
		{ rejectWithValue }
	) => {
		try {
			const companyId = localStorage.getItem('companyId');
			const response = await getApi('/expense-journal', {
				companyId,
				page: params.page || 1,
				limit: params.limit || 10,
				search: params.search || '',
				status: params.status || '',
				sort: params.sort || 'date',
				sortType: params.sortType || 'desc',
				year: params.year,
			});

			// Ensure the response has the expected structure for lazy loading
			const data = response.data?.data || response.data;
			return {
				data: {
					expenseJournals: data?.expenseJournals || [],
					count: data?.count || 0,
					totalPages:
						data?.totalPages ||
						Math.ceil((data?.count || 0) / (params.limit || 10)),
				},
			};
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

// Delete Expense Journal
export const deleteExpenseJournalAction = createAsyncThunk(
	'expenseJournal/deleteJournal',
	async (id: string, { rejectWithValue }) => {
		try {
			const companyId = localStorage.getItem('companyId');
			const response = await deleteApi(
				`/expense-journal/${id}?companyId=${companyId}`
			);
			return { id, response: response.data };
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
